module.exports = __webpack_public_path__ + "static/corian-35bf5d0c4db7a74cdbe7b10a97ee30ea.jpg";